/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseRegister
 */
export interface HorseRegister {
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    bookerEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    breedId: number;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    gender: string;
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    colorId: number;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegister
     */
    birthday: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    owner: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    mother: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    father: string;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegister
     */
    registerDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    remark?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    size?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    lNr: string;
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    fatherBreedId?: number;
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    motherBreedId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HorseRegister
     */
    isBigHorse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    fatherRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    motherRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    ownerRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    breederRegisterId?: string | null;
}

/**
 * Check if a given object implements the HorseRegister interface.
 */
export function instanceOfHorseRegister(value: object): value is HorseRegister {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('breedId' in value) || value['breedId'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('colorId' in value) || value['colorId'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('mother' in value) || value['mother'] === undefined) return false;
    if (!('father' in value) || value['father'] === undefined) return false;
    if (!('lNr' in value) || value['lNr'] === undefined) return false;
    return true;
}

export function HorseRegisterFromJSON(json: any): HorseRegister {
    return HorseRegisterFromJSONTyped(json, false);
}

export function HorseRegisterFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseRegister {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'bookerEmail': json['bookerEmail'] == null ? undefined : json['bookerEmail'],
        'name': json['name'],
        'breedId': json['breedId'],
        'gender': json['gender'],
        'colorId': json['colorId'],
        'birthday': (new Date(json['birthday'])),
        'owner': json['owner'],
        'mother': json['mother'],
        'father': json['father'],
        'registerDate': json['registerDate'] == null ? undefined : (new Date(json['registerDate'])),
        'remark': json['remark'] == null ? undefined : json['remark'],
        'size': json['size'] == null ? undefined : json['size'],
        'lNr': json['lNr'],
        'fatherBreedId': json['fatherBreedId'] == null ? undefined : json['fatherBreedId'],
        'motherBreedId': json['motherBreedId'] == null ? undefined : json['motherBreedId'],
        'isBigHorse': json['isBigHorse'] == null ? undefined : json['isBigHorse'],
        'fatherRegisterId': json['fatherRegisterId'] == null ? undefined : json['fatherRegisterId'],
        'motherRegisterId': json['motherRegisterId'] == null ? undefined : json['motherRegisterId'],
        'ownerRegisterId': json['ownerRegisterId'] == null ? undefined : json['ownerRegisterId'],
        'breederRegisterId': json['breederRegisterId'] == null ? undefined : json['breederRegisterId'],
    };
}

export function HorseRegisterToJSON(json: any): HorseRegister {
    return HorseRegisterToJSONTyped(json, false);
}

export function HorseRegisterToJSONTyped(value?: HorseRegister | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bookerId': value['bookerId'],
        'bookerEmail': value['bookerEmail'],
        'name': value['name'],
        'breedId': value['breedId'],
        'gender': value['gender'],
        'colorId': value['colorId'],
        'birthday': (() => { const d = value['birthday']; return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` })(),
        'owner': value['owner'],
        'mother': value['mother'],
        'father': value['father'],
        'registerDate': value['registerDate'] == null ? undefined : ((value['registerDate']).toISOString()),
        'remark': value['remark'],
        'size': value['size'],
        'lNr': value['lNr'],
        'fatherBreedId': value['fatherBreedId'],
        'motherBreedId': value['motherBreedId'],
        'isBigHorse': value['isBigHorse'],
        'fatherRegisterId': value['fatherRegisterId'],
        'motherRegisterId': value['motherRegisterId'],
        'ownerRegisterId': value['ownerRegisterId'],
        'breederRegisterId': value['breederRegisterId'],
    };
}

